import { createApp } from "vue";
import App from "./App.vue";
import PrimeVue from "primevue/config";
import Button from "primevue/button";
import Dropdown from "primevue/dropdown";
import "./assets/styles.scss";
import { BootstrapIconsPlugin } from "bootstrap-icons-vue";
import vReveal from "./directives/v-reveal.js";
import vTilt from "./directives/v-tilt.js";
import vDecrypt from "./directives/v-decrypt.js";
import Particles from "@tsparticles/vue3";
import { loadFull } from "tsparticles";
import i18n from "./i18n";
import content from "./content/content.json";
import { EDITION_KEY, loadEdition } from "./editions";

async function bootstrap() {
  const edition = await loadEdition();
  if (edition.isArchive) {
    document.title = `${document.title} ${edition.year}`;
  }

  createApp(App, { source: edition.content })
    .provide(
      EDITION_KEY,
      Object.freeze({ year: edition.year, isArchive: edition.isArchive }),
    )
    .use(i18n, { messages: content.ui })
    .use(PrimeVue)
    .use(BootstrapIconsPlugin)
    .use(Particles, {
      init: async (engine) => {
        await loadFull(engine);
      },
    })
    .component("Dropdown", Dropdown)
    .component("Button", Button)
    .directive("reveal", vReveal)
    .directive("tilt", vTilt)
    .directive("decrypt", vDecrypt)
    .mount("#app");
}

bootstrap();
